import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Client } from '@classes/client';

@Component({
  selector: 'app-crm-filter-form',
  templateUrl: './crm-filter-form.component.html',
  styleUrls: ['./crm-filter-form.component.scss']
})
export class CRMFilterFormComponent {

  @Input() filterForm: FormGroup = null;
  @Input() clients: Client[] = [];

  @Output() onFilterFormSubmited: EventEmitter<void> = new EventEmitter<void>();
  @Output() onFilterFormReset: EventEmitter<void> = new EventEmitter<void>();

  // State
  public panelExpanded: boolean = true;
  public displayFilter: string = "";

  public onClearFilters() {
    this.onFilterFormReset.next();
    this._updateDisplayFilter();
  }

  public onSubmitFilterForm() {
    this.onFilterFormSubmited.next();
    this.panelExpanded = false;
    this._updateDisplayFilter();
  }

  private _updateDisplayFilter() {
    if (this.filterForm.valid) {
      const client = this.filterForm.get('client').value;
      const startDate = new Date(this.filterForm.get('startDate').value);
      const endDate = new Date(this.filterForm.get('endDate').value);

      this.displayFilter = ` ${client.name} du ${startDate.toLocaleDateString()} au ${endDate.toLocaleDateString()}`;
    }
    else {
      this.displayFilter = "";
    }
  }
}
